import { render, staticRenderFns } from "./MealBreakDetails.vue?vue&type=template&id=0552940c&"
import script from "./MealBreakDetails.vue?vue&type=script&lang=js&"
export * from "./MealBreakDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports